module.exports = __webpack_public_path__ + "static/media/trivvy-logo-img.9e2a26b5.png";